// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const CarFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M17 7.52V5a1.91 1.91 0 00-1.81-2H3.79A1.91 1.91 0 002 5v10a2 2 0 001.2 1.88 3 3 0 105.6.12h6.36a3 3 0 105.64 0h.2a1 1 0 001-1v-4a1 1 0 00-.4-.78L17 7.52zm3 4.96V15h-3v-4.92l3 2.4zM6 19a1 1 0 110-2 1 1 0 010 2zm12 0a1 1 0 110-2 1 1 0 010 2z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export const CarFillOffset: IconOffset = {
    vertical: 10,
    horizontal: 6,
};

export default React.memo(CarFill);
